var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_1482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66503 8.95697C7.50937 8.80947 7.42192 8.60941 7.42192 8.40081C7.42192 8.19221 7.50937 7.99215 7.66503 7.84465C7.82068 7.69714 8.0318 7.61427 8.25193 7.61427C8.47205 7.61427 8.68317 7.69714 8.83882 7.84464L14.1421 12.8702L19.4454 7.84465C19.6011 7.69714 19.8122 7.61427 20.0323 7.61427C20.2525 7.61427 20.4636 7.69714 20.6192 7.84465C20.7749 7.99215 20.8623 8.19221 20.8623 8.40081C20.8623 8.60941 20.7749 8.80947 20.6192 8.95697L15.3159 13.9825L20.6192 19.0081C20.6963 19.0812 20.7574 19.1679 20.7991 19.2633C20.8409 19.3587 20.8623 19.461 20.8623 19.5643C20.8623 19.6676 20.8409 19.7698 20.7991 19.8653C20.7574 19.9607 20.6963 20.0474 20.6192 20.1204C20.5422 20.1935 20.4507 20.2514 20.35 20.2909C20.2493 20.3305 20.1413 20.3508 20.0323 20.3508C19.9233 20.3508 19.8154 20.3305 19.7147 20.2909C19.614 20.2514 19.5225 20.1935 19.4454 20.1204L14.1421 15.0949L8.83882 20.1204C8.76175 20.1935 8.67025 20.2514 8.56955 20.2909C8.46885 20.3305 8.36092 20.3508 8.25193 20.3508C8.14293 20.3508 8.035 20.3305 7.9343 20.2909C7.8336 20.2514 7.7421 20.1935 7.66503 20.1204C7.58795 20.0474 7.52682 19.9607 7.4851 19.8653C7.44339 19.7698 7.42192 19.6676 7.42192 19.5643C7.42192 19.461 7.44339 19.3587 7.4851 19.2633C7.52682 19.1679 7.58795 19.0812 7.66503 19.0081L12.9683 13.9825L7.66503 8.95697Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_1482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4833,
    height: 19.4833,
    fill: "white",
    transform: "matrix(0.725858 -0.687845 0.725858 0.687845 0 13.9825)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseColor);
export default __webpack_public_path__ + "static/media/close-color.1e487858f7e8e534c19d34fe2a1c2e71.svg";
export { ForwardRef as ReactComponent };